<section class="home-faq" id="faq" aria-labelledby="home-faq-title">
  <div class="inner">
    <header class="home-faq-head">
      <h2 id="home-faq-title">Häufige Fragen</h2>
      <p>Die wichtigsten Antworten auf einen Blick – von Dart spielen bis Öffnungszeiten.</p>
    </header>

    <ul class="home-faq-list" role="list">
      <li class="home-faq-item"
          *ngFor="let item of items; trackBy: trackById"
          [class.open]="isOpen(item.id)">
        <button type="button"
                class="home-faq-question"
                [attr.aria-expanded]="isOpen(item.id)"
                [attr.aria-controls]="'home-answer-' + item.id"
                [id]="'home-question-' + item.id"
                (click)="toggle(item.id)"
                (keydown)="onKeydown($event, item.id)">
          <span class="q-text">{{ item.question }}</span>
          <span class="q-icon" aria-hidden="true"></span>
        </button>
        <div class="home-faq-answer"
             [id]="'home-answer-' + item.id"
             role="region"
             [attr.aria-labelledby]="'home-question-' + item.id"
             [attr.hidden]="isOpen(item.id) ? null : true">
          <p>{{ item.answer }}</p>
        </div>
      </li>
    </ul>

    <div class="home-faq-more">
      <a [routerLink]="['/faq']">Alle 26 Fragen ansehen &rarr;</a>
    </div>
  </div>
</section>
